import React, { useState, useRef, useEffect } from "react";
import HeaderMenu from "../../Header/header-menu";
import Header from "../../Header/header";
import Footer from "../../Footer/Footer";
import Isi from "../../ISI/Isi";
import NavigationBar from "../../NavigationBar/NavigationBar";
import './How-to-use-inbrija.css'
import { Link, useLocation, useNavigate } from "react-router-dom";
import IsiFrame from '../../ISI/Isi-frame';
import { Helmet } from "react-helmet";
import Modal from '../Modal';
import MainLayout from "../../Layouts/Main_Layout";

export default function HowToUseInbrija() {

  const [whenINB, setWhenINB] = useState(false);
  const [learnINB, setLearnINB] = useState(false)
  const [nurse, setNurse] = useState(false)
  const [help, setHelp] = useState(false)
  const [play, setPlay] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showJimmy, setShowJimmy] = useState(false)
  const myRef = useRef(null)
  const learnInb = useRef(null)
  const nurseRef = useRef(null)
  const helpful = useRef(null)
  const [show, setShow] = useState(true);
  const [chromeVersion, setChromeVersion] = useState(100);

  const getChromeVersion = () => {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (raw) {
      return parseInt(raw[2], 10);
    }
  }

  const executeScroll = () => {
    var element = myRef.current;
    var headerOffset = 39;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    if (chromeVersion > 60) {
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    else {
      window.scrollTo(0, offsetPosition);
    }
    setShow(true)
  }
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const handleImageLoads = () => {
    // Check if all images have finished loading
    const allImagesLoaded = Array.from(document.querySelectorAll('img')).every((image) => image.complete);

    if (allImagesLoaded) {
      setImagesLoaded(true);
    }
  };

  function handleScrollCSS() {
    if (document.getElementById('how-to-use-page')) {
      var element = document.getElementById('whenInb');
      var offsetTop1 = element.offsetTop - 100;
      var element2 = document.getElementById('learnInb');
      var offsetTop2 = element2.offsetTop - 100;
      var elementBottom2 = document.getElementById('nurseEduSupport');
      var offsetTopBottom2 = elementBottom2.offsetTop - 100;
      var element3 = document.getElementById('nurseEduSupport');
      var offsetTop3 = element3.offsetTop - 100;
      var elementBottom3 = document.getElementById('when-to-use');
      var offsetTopBottom3 = elementBottom3.offsetTop;
      var element4 = document.getElementById('helpful');
      var offsetTop4 = element4.offsetTop - 100;
      // case 1
      if (window.scrollY > offsetTop1) {
        document.getElementById('when-link').classList.add('submenu-style-active');
      }
      if (window.scrollY > offsetTop2 || window.scrollY < offsetTop1) {
        document.getElementById('when-link').classList.remove('submenu-style-active');
        document.getElementById('when-link').classList.add('submenu-style-not-active');
      }

      if (window.scrollY > offsetTop2) {
        document.getElementById('learn-link').classList.add('submenu-style-active');
      }
      if (window.scrollY > offsetTopBottom2 || window.scrollY < offsetTop2) {
        document.getElementById('learn-link').classList.remove('submenu-style-active');
        document.getElementById('learn-link').classList.add('submenu-style-not-active');
      }

      if (window.scrollY > offsetTop3) {
        document.getElementById('nurse-link').classList.add('submenu-style-active');
      }
      if (window.scrollY > offsetTop4 || window.scrollY < offsetTop3) {
        document.getElementById('nurse-link').classList.remove('submenu-style-active');
        document.getElementById('nurse-link').classList.add('submenu-style-not-active');
      }
      if (window.scrollY > offsetTop4) {
        document.getElementById('help-link').classList.add('submenu-style-active');
      }
      else {
        document.getElementById('help-link').classList.remove('submenu-style-active');
        document.getElementById('help-link').classList.add('submenu-style-not-active');
      }
    }
  }

  const handleVideoClick = (eventType, clickClass) => {
    window.gtag('event', eventType, {
      'event_category': 'video_start',
      'event_label': clickClass,
      'page_location': window.location.href
    });
  }

  useEffect(() => {
    setChromeVersion(getChromeVersion());
    document.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('button')) {
        if (typeof window !== 'undefined') {
          if (document.location.pathname.includes('/what-are-off-periods')) {
            window.gtag('event', 'what_are_off_periods_buttons');
          }
          if (document.location.pathname.includes('/about-inbrija')) {
            window.gtag('event', 'about_inbrija_buttons');
          }
          if (document.location.pathname.includes('/how-to-use-inbrija')) {
            window.gtag('event', 'how_to_use_inbrija_buttons');
          }
          if (document.location.pathname.includes('/savings-and-support')) {
            window.gtag('event', 'savings_and_support_buttons');
          }
        }
      }
    });
    handleScrollCSS();
    if (location.hash === '#when-to-use') {
      var element = document.getElementById('whenInb');
      var headerOffset = 39;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      if (chromeVersion > 60) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
      else {
        window.scrollTo(0, offsetPosition);
      }
      setWhenINB(true);
      setLearnINB(false);
      setNurse(false);
      setHelp(false)
    }

    setTimeout(() => {
      if (location.hash === '#learn-how-use-inbrija') {
        var element = document.getElementById('learnInb');
        var headerOffset = 20;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        if (chromeVersion > 60) {
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
        else {
          window.scrollTo(0, offsetPosition);
        }
        setWhenINB(false);
        setLearnINB(true);
        setNurse(false);
        setHelp(false)
      }
    }, 500);

    setTimeout(() => {
      if (location.hash === '#peter-demo') {
        var element = document.getElementById('learnInb');
        var headerOffset = 20;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        if (chromeVersion > 60) {
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
        else {
          window.scrollTo(0, offsetPosition);
        }
        setWhenINB(false);
        setLearnINB(true);
        setNurse(false);
        setHelp(false);
        setPlay(true);
        let el = document.querySelector('.demo-video');
        const video = el.querySelector('video');
        video.muted = false;
        let playbackerror = video.play();
        let trackElem = el.querySelector('track');
        if (playbackerror !== undefined) {
          playbackerror.then(function () {
            // Autoplay started!
            if (trackElem !== undefined) {
              let track1 = trackElem.track;
              track1.mode = 'hidden';
            }
          }).catch(function (error) {
            if (trackElem !== undefined) {
              let track = trackElem.track;
              track.mode = 'showing';
            }
            video.muted = true;
            video.play();
          });
        }
      }
    }, 500);

    if (location.hash === '#nurse-educator-support') {
      var element = document.getElementById('nurseEduSupport');
      var headerOffset = 20;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      if (chromeVersion > 60) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
      else {
        window.scrollTo(0, offsetPosition);
      }
      setWhenINB(false);
      setLearnINB(false);
      setNurse(true);
      setHelp(false)
    }

    setTimeout(() => {
      if (location.hash === '#nurse-educator') {

        var element = document.getElementById('nurseEduSupport');
        var headerOffset = 39;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        if (chromeVersion > 60) {
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
        else {
          window.scrollTo(0, offsetPosition);
        }
        setWhenINB(false);
        setLearnINB(false);
        setNurse(true);
        setHelp(false)
      }
    }, 500);

    if (location.hash === '#helpful-hints') {
      helpful.current.scrollIntoView({ behavior: 'smooth' });
      setWhenINB(false);
      setLearnINB(false);
      setNurse(false);
      setHelp(true)
    }

    if (location.pathname === '/how-to-use-inbrija' || location.pathname === '/how-to-use-inbrija/') {
      var windowHeight = window.innerHeight;
      var windowWidth = window.innerWidth;
      var header = document.getElementById('submenu');

      window.addEventListener('scroll', function () {
        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollPosition > windowHeight) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
        if (windowWidth > 767) {
          header.classList.remove('sticky');
        }
      });
    }

    const handleHashChange = () => {
      // Reset the images loaded status
      setImagesLoaded(false);
    };

    window.addEventListener('hashchange', handleHashChange);

    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("scroll", handleScrollCSS);

        return () => {
          window.removeEventListener("scroll", handleScroll);
          window.removeEventListener("scroll", handleScrollCSS);
        };
      }
    };
    calculateOffset();
    window.addEventListener('resize', calculateOffset);

    return () => {
      window.removeEventListener('resize', calculateOffset);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [location, imagesLoaded]);

  if (imagesLoaded) {
    var windowHeight = window.innerHeight;
    var header = document.getElementById('submenu');

    window.addEventListener('scroll', function () {
      var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const offsetTop = header.offsetTop;
      if (scrollPosition > offsetTop) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    });
  }

  const handlePdf = () => {
    var ddg_file = '/pdfs/inbrija-patient-info-IFU.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const handlePatientIfuPdf = () => {
    var ddg_file = '/pdfs/inbrija-patient-info-IFU.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const handleInstPdf = () => {
    var ddg_file = '/pdfs/inbrija-instructions-for-use.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const handleHelpfulPdf = () => {
    var ddg_file = '/pdfs/helpful-hints.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const DisableClick = () => {
    if (chromeVersion < 60) {
      return "disable-link-click"
    }
    else {
      return ""
    }
  }

  return (
    <MainLayout>
      <div className="how-to-use-page" id="how-to-use-page">
        <Helmet>
          <title>How to Use INBRIJA® | INBRIJA® (levodopa inhalation powder)</title>
          <meta property='og:title' content={`How to Use INBRIJA® | INBRIJA®  (levodopa inhalation powder)`} />
          <meta property='og:description' content={`Discover resources to help you learn how to use INBRIJA including helpful hints, a demonstration video, and the full Instructions For Use.`} />
          <meta property='og:site_name' content='INBRIJA.COM' />
          <meta property='og:type' content='website' />
          <meta name='description' content={`Discover resources to help you learn how to use INBRIJA including helpful hints, a demonstration video, and the full Instructions For Use.`} />
          <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
          <meta property='og:url' content='https://inbrija.com/how-to-use-inbrija' />
          <meta property='og:image:alt' content='INBRIJA logo' />
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className="container-1500">
            <div className='hero-section'>
              <div className='hero-section-image'>
                <img
                  onLoad={handleImageLoads}
                  src="/assets/images/Tennis-Player-actor.webp"
                  className='img-fluid show_desktop'
                  alt={`A man holds a tennis racket over his shoulder. Words are written in the center of the racket that say "I am shaking. I am slow. I'll fight to play."`} />

                <img
                  src="/assets/images/Tennis-Player-actor.webp"
                  className='img-fluid show_mobile'
                  onLoad={handleImageLoads}
                  alt={`A man holds a tennis racket over his shoulder. Words are written in the center of the racket that say "I am shaking. I am slow. I'll fight to play."`} />
                <div className="actor_portrayal">Actor portrayal.</div>
              </div>
              <div className='hero-section-content'>
                <h1>How to use <span>INBRIJA</span></h1>
                <h4 className="">Use INBRIJA as needed when Parkinson's disease (PD) symptoms return (also known as OFF episodes).</h4>
              </div>
            </div>
          </div>
        </HeaderMenu>
        <div className="menu-bar-sticky-desktop">
          <div className="brush-style-2 how-to-use-brush" id="submenu">
            <div className="submenu-style">
              <Link className="text-decoration-none" to='/how-to-use-inbrija#when-to-use'> <div id="when-link" className={whenINB ? 'submenu-style-active' : 'submenu-style-not-active'}>When to Use INBRIJA</div></Link>
              <Link className="text-decoration-none" to="/how-to-use-inbrija#learn-how-use-inbrija"><div id="learn-link" className={learnINB ? 'submenu-style-active' : 'submenu-style-not-active'}>Learn How to Use INBRIJA</div></Link>
              <Link className="text-decoration-none" to="/how-to-use-inbrija#nurse-educator-support"> <div id="nurse-link" className={nurse ? 'submenu-style-active' : 'submenu-style-not-active'}>Nurse Educator Support</div></Link>
              <Link className="text-decoration-none" to="/how-to-use-inbrija#helpful-hints">   <div id="help-link" className={help ? 'submenu-style-active' : 'submenu-style-not-active'}>Helpful Hints</div></Link>
            </div>
          </div>
        </div>
        <div className="menu-bar-sticky-mobile">
          <div className="brush-style-2 mobile-header-sticky">
          </div>
        </div>
        <div className="inbrija-fight" id="whenInb">
          <h1>Use INBRIJA as needed* to fight Parkinson's <br className="br-desktop" /> symptoms when they return. </h1>
          <h6>
            *1 dose (2 capsules) per OFF Episode,<br className="br-mobile" /> no more than 5 doses per day. <br />
            INBRIJA is not a substitute for your regular carbidopa/levodopa medication.
          </h6>
          <p><a href="https://dailymed.nlm.nih.gov/dailymed/getFile.cfm?setid=a906f8e1-6e1c-480a-8276-c01bc65dd3be&type=pdf" target="_blank" rel="noreferrer">Please see Full Prescribing Information</a>.</p>
        </div>

        <div className="jimmy-video" id="jimmy-video">
            <div className="jimmy-video-container">
                <div className="jimmy-video-container-content">
                    <h1>Jimmy uses INBRIJA<span> WHERE</span> he wants to use it...</h1>
                    <p>
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="comma">
                            <path d="M2.53548 12.1789C2.3885 12.1973 2.29664 11.7564 2.14048 11.9034C1.9292 11.5359 1.71792 11.2236 1.47909 10.9756C1.36886 10.8653 1.29537 10.7184 1.26781 10.5346C1.22188 10.2407 0.670718 10.2774 0.64316 10.0019C0.624788 9.72627 0.588044 9.44151 0.542114 9.15674C0.496184 8.74337 0.00932484 8.53209 0.000138827 8.10954C-0.00904719 7.68698 0.441068 6.97966 0.330835 6.61222C0.101185 6.0335 0.000138826 5.4364 0.0368829 4.83931C0.073627 4.23304 1.20351 3.44304 1.20351 2.85513C1.20351 2.52444 1.28618 2.24886 1.44234 2.02839C1.60769 1.80793 1.79141 1.61502 1.9935 1.44967C2.20478 1.28433 2.42525 1.12816 2.6549 0.981187C2.88455 0.834211 3.06827 0.687234 3.20606 0.540258C3.27955 0.46677 3.32548 0.384096 3.34385 0.292236C3.36222 0.200375 3.38059 0.126887 3.38059 0.0717712C3.38059 0.0166551 3.38059 -0.0017169 3.39896 0.0166551C3.40815 0.0350272 3.46327 0.117701 3.55513 0.264678C3.67455 0.411654 3.77559 0.55863 3.88582 0.705606C3.98687 0.852583 4.0971 1.01793 4.21652 1.20165C4.51966 1.45886 4.70338 1.78037 4.78605 2.16618C4.86873 2.552 4.90547 2.99292 4.90547 3.50734C4.93303 4.41676 3.83989 5.53745 3.85827 6.44687C3.88582 7.35628 5.13512 8.52291 5.13512 9.46907C5.16268 9.76302 5.18105 10.0845 5.20861 10.4244C5.23617 10.7735 5.7414 10.7919 5.69547 11.1225C5.62198 11.4165 5.52093 11.6829 5.38314 11.9217C5.24535 12.1606 3.81234 12.2984 3.69292 12.5556C3.64699 12.6291 3.26117 12.7301 3.07745 12.6382C2.89373 12.5464 2.90292 12.4178 2.85699 12.2341C2.74676 11.9034 2.89373 11.885 2.74676 11.9034" fill="#FFB423" />
                            <path d="M8.70818 11.6548C8.58876 11.7925 8.35911 11.7466 8.15702 11.7558C7.75283 11.7742 7.81714 11.223 7.58749 10.9658C7.47725 10.8556 7.40377 10.7086 7.37621 10.5249C7.33028 10.2309 6.77912 10.2677 6.75156 9.99209C6.724 9.71651 6.69644 9.43174 6.65051 9.14698C6.60458 8.74279 6.11772 8.53151 6.10854 8.10896C6.09935 7.6864 6.54947 6.97908 6.43923 6.61164C6.20958 6.02373 6.10854 5.43583 6.14528 4.82955C6.18203 4.22327 7.31191 3.43327 7.31191 2.84537C7.31191 2.51467 7.39458 2.23909 7.55074 2.01863C7.71609 1.79816 7.89981 1.60526 8.1019 1.43991C8.304 1.27456 8.52446 1.1184 8.75411 0.971421C8.98376 0.824445 9.16748 0.677469 9.30527 0.530492C9.36957 0.457004 9.42469 0.37433 9.44306 0.28247C9.47062 0.19061 9.47981 0.117122 9.47981 0.0620056C9.47981 0.00688951 9.47981 -0.0114825 9.49818 0.00688951C9.50736 0.0252615 9.56248 0.107936 9.65434 0.254912C9.77376 0.401888 9.8748 0.548864 9.98504 0.695841C10.0861 0.842817 10.1963 1.00817 10.3157 1.19189C10.6189 1.44909 10.8026 1.7706 10.8853 2.15642C10.9679 2.54223 11.0047 2.99234 11.0047 3.49758C11.0322 4.40699 9.93911 5.52769 9.95748 6.4371C9.97585 7.34652 11.4456 8.44884 11.4456 9.40418C11.464 9.69814 11.4915 10.0196 11.5099 10.3595C11.5283 10.7086 12.0427 10.727 11.9968 11.0577C11.9325 11.3516 11.8222 11.618 11.6845 11.8569C11.5467 12.0957 11.4181 12.3437 11.3078 12.6009C11.2619 12.6744 9.62678 12.6193 9.44306 12.5274C9.25934 12.4356 9.14911 12.2978 9.09399 12.1141C8.98376 11.7834 8.84597 11.6272 8.69899 11.6456" fill="#FFB423" />
                        </svg>
                        I&rsquo;ve been using it a couple of years now and I&rsquo;ll do it in front of anybody, in a restaurant or anywhere.
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="comma-down">
                            <path d="M9.46452 0.495865C9.6115 0.477492 9.70336 0.918421 9.85952 0.771444C10.0708 1.13888 10.2821 1.45121 10.5209 1.69923C10.6311 1.80946 10.7046 1.95644 10.7322 2.14016C10.7781 2.43411 11.3293 2.39737 11.3568 2.67295C11.3752 2.94853 11.412 3.2333 11.4579 3.51806C11.5038 3.93143 11.9907 4.14271 11.9999 4.56527C12.009 4.98783 11.5589 5.69515 11.6692 6.06259C11.8988 6.64131 11.9999 7.2384 11.9631 7.83549C11.9264 8.44177 10.7965 9.23177 10.7965 9.81967C10.7965 10.1504 10.7138 10.4259 10.5577 10.6464C10.3923 10.8669 10.2086 11.0598 10.0065 11.2251C9.79522 11.3905 9.57475 11.5466 9.3451 11.6936C9.11545 11.8406 8.93173 11.9876 8.79394 12.1345C8.72045 12.208 8.67452 12.2907 8.65615 12.3826C8.63778 12.4744 8.61941 12.5479 8.61941 12.603C8.61941 12.6581 8.61941 12.6765 8.60104 12.6581C8.59185 12.6398 8.53673 12.5571 8.44487 12.4101C8.32545 12.2632 8.22441 12.1162 8.11418 11.9692C8.01313 11.8222 7.9029 11.6569 7.78348 11.4732C7.48034 11.2159 7.29662 10.8944 7.21395 10.5086C7.13127 10.1228 7.09453 9.68188 7.09453 9.16746C7.06697 8.25805 8.16011 7.13735 8.14173 6.22794C8.11418 5.31852 6.86488 4.1519 6.86488 3.20574C6.83732 2.91179 6.81895 2.59028 6.79139 2.25039C6.76383 1.90132 6.2586 1.88295 6.30453 1.55226C6.37802 1.2583 6.47907 0.991909 6.61686 0.753072C6.75465 0.514236 8.18767 0.376445 8.30708 0.119237C8.35301 0.0457484 8.73883 -0.0552972 8.92255 0.0365636C9.10627 0.128423 9.09708 0.257027 9.14301 0.440748C9.25324 0.771444 9.10627 0.789816 9.25324 0.771444" fill="#FFB423" />
                            <path d="M3.29182 1.01907C3.41124 0.88128 3.64089 0.927209 3.84298 0.918023C4.24717 0.899651 4.18286 1.45081 4.41251 1.70802C4.52275 1.81825 4.59624 1.96523 4.62379 2.14895C4.66972 2.4429 5.22088 2.40616 5.24844 2.68174C5.276 2.95732 5.30356 3.24209 5.34949 3.52685C5.39542 3.93104 5.88228 4.14231 5.89146 4.56487C5.90065 4.98743 5.45053 5.69475 5.56077 6.06219C5.79042 6.6501 5.89146 7.238 5.85472 7.84428C5.81797 8.45056 4.68809 9.24055 4.68809 9.82846C4.68809 10.1592 4.60542 10.4347 4.44926 10.6552C4.28391 10.8757 4.10019 11.0686 3.8981 11.2339C3.696 11.3993 3.47554 11.5554 3.24589 11.7024C3.01624 11.8494 2.83252 11.9964 2.69473 12.1433C2.63043 12.2168 2.57531 12.2995 2.55694 12.3914C2.52938 12.4832 2.52019 12.5567 2.52019 12.6118C2.52019 12.6669 2.52019 12.6853 2.50182 12.6669C2.49264 12.6486 2.43752 12.5659 2.34566 12.4189C2.22624 12.2719 2.1252 12.125 2.01496 11.978C1.91392 11.831 1.80369 11.6657 1.68427 11.4819C1.38113 11.2247 1.19741 10.9032 1.11473 10.5174C1.03206 10.1316 0.995316 9.68148 0.995316 9.17625C0.967758 8.26684 2.06089 7.14614 2.04252 6.23673C2.02415 5.32731 0.554387 4.22499 0.554387 3.26964C0.536015 2.97569 0.508457 2.65418 0.490085 2.3143C0.471714 1.96523 -0.0427041 1.94686 0.00322582 1.61616C0.0675278 1.32221 0.17776 1.05581 0.31555 0.816977C0.453341 0.578141 0.581945 0.330119 0.692177 0.0729099C0.738107 -0.000578377 2.37322 0.0545384 2.55694 0.146398C2.74066 0.238258 2.85089 0.376049 2.90601 0.559768C3.01624 0.890465 3.15403 1.04663 3.30101 1.02826" fill="#FFB423" />
                        </svg>
                    </p>
                    <div className="ll patient-name">—Jimmy, person with Parkinson's</div>
                    <p className="small">Actual Patient. Individual Results may vary.</p>
                </div>
                <div className="jimmy-video-container-video-desktop">
                    <div className="play-jimmy-video">
                        <a onClick={() => {setShowJimmy(true); handleVideoClick('patient_video','play-jimmy-video')}}>
                            <img
                                className="img-fluid jimmy-stories-img"
                                src="/assets/images/Jimmy-Image 1.webp"
                                onLoad={handleImageLoads}
                                alt="A man uses INBRIJA while on a dinner date with a woman. "
                            />
                            <div className="jimmy-video-patient-name show_mobile">
                                <div className="jimmy-video-patient" >
                                    <img src="/assets/images/Group 137.webp"
                                        onLoad={handleImageLoads}
                                        className="video-play-button" />
                                    <span >Watch Jimmy’s Story</span>
                                </div>
                            </div>
                            <div className="jimmy-video-patient-name show_desktop">
                                <div className="jimmy-video-patient" style={{ display: 'flex' }} >
                                    <div className="video-button"></div>
                                    <span >Watch Jimmy’s Story</span>
                                </div>

                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>


        <div className="how-to-use-inbrija ask-peter-video-demo" ref={learnInb} id="learnInb">
          <h3>How to Use INBRIJA</h3>
          <p>Needing a few tries to get used to using your inhaler is normal when getting started with INBRIJA.<br className="br-desktop" /> Don't feel discouraged—that's normal! Peter is here to help with a step-by-step guide on how to use INBRIJA. <br className="br-desktop" />If you have more questions, check out more of Peter's videos for extra guidance about INBRIJA.</p>
          <a id="how_helpful_hints_anchor" onClick={() => navigate('/how-to-use-inbrija#helpful-hints')}>More helpful hints for using INBRIJA</a>
        </div>
        <div className="demo-video">
          {play ?
            <video controls autoPlay playsInline onLoad={handleImageLoads} muted={false} title="Demonstration Video">
              <source src="/videos/inbrija-demonstration-video.mp4" type="video/mp4" />
              <track src="/videos/inbrija-demonstration-video.vtt" kind="captions" srcLang="en" label="English" default />
            </video>
            : <img
              src="/assets/website_images/peter-video-thumbnail.webp"
              className="pointer img-fluid"
              alt="Peter, an animated figure, holds the INBRIJA inhaler in his hands while standing in a kitchen."
              onLoad={handleImageLoads}
              id="how_play_peter"
              onClick={() => { setPlay(true); handleVideoClick('demo_video', 'how_play_peter') }} />}
          <div className="transcript">
            <a href="https://dailymed.nlm.nih.gov/dailymed/getFile.cfm?setid=a906f8e1-6e1c-480a-8276-c01bc65dd3be&type=pdf" target="_blank" rel="noreferrer" className={DisableClick()} id="how_PIL1" >
              Please see Full Prescribing Information
            </a>
            <a target="_blank" href="/videos/inbrija-demonstration-video-transcript.html" id="how_peter_transcript">Read Transcript</a>
          </div>
        </div>
        <div className="nurse-reference" id="nurseEduSupport">
          <div className="nurse-reference-left">
            <div className="nurse-reference-left-content">
              <h3>Have more questions?</h3>
              <p>Peter is here to help. Check out other Peter videos, like "When to Use INBRIJA" and "What Can I Do to Help With Cough When Using INBRIJA?"</p>
              <a href='/common-questions#peter-videos' id="how_ask_peter_button">More Just Ask Peter<sup>SM</sup> Videos</a>
            </div>
          </div>
          <div className="nurse-reference-middle">

          </div>
          <div className='nurse-reference-right'>
            <div className='nurse-support-contianer-wrap'>
              <h1>Nurse Educators are here to help</h1>
              <div className='nurse-support-contiainer-wrap-image'>
                <img
                  onLoad={handleImageLoads}
                  src='/assets/images/nurse-educator.webp' alt='Head shot of a Nurse Educator smiling' className='img-fluid' />
                <p>Actor portrayal.</p>
              </div>
              <div className='nurse-support-contiainer-wrap-content'>
                <h3>Nurse Educators are available to support you with additional training by phone or video and to answer any questions about how to use the inhaler.</h3>
                <div className="call-toll-free show_mobile"><span className="content-text">You may contact them at</span><span className='content-number'><a href="tel:1-888-887-3447" className="secondry-button">1-888-887-3447</a><span>8 <small>AM</small> to 8 <small>PM</small> ET. <br />Monday through Friday</span></span></div>
              </div>
              <div className="call-toll-free show_desktop"><span className="content-text">You may contact them at</span><span className='content-number'><a href="tel:1-888-887-3447" className="secondry-button" id="how_888">1-888-887-3447</a><span>8 <small>AM</small> to 8 <small>PM</small> ET. <br />Monday through Friday</span></span></div>
            </div>
          </div>
        </div>

        <div className="use-inbrija-as-needed" id="when-to-use">
          <div className="use-inbrija-as-needed-container">
            <div className="use-inbrija-as-needed-container-image">
              <img
                onLoad={handleImageLoads}
                src="/assets/images/MicrosoftTeams-image.webp" className='img-fluid show_desktop' alt="Close crop of a hand holding the INBRIJA inhaler." />
              <img
                onLoad={handleImageLoads}
                src="/assets/images/inhaler.webp" className='img-fluid show_mobile' alt="Close crop of a hand holding the INBRIJA inhaler." />
            </div>
            <div className="use-inbrija-as-needed-container-content">
              <h3>Use INBRIJA as needed when symptoms return in between doses of your carbidopa/levodopa medicine.</h3>
              <ul>
                <li><b>Do not orally inhale more than 1 dose</b> (2 capsules) for any OFF period. Do not take more than 5 doses (10 capsules) in a day</li>
                <li><b>Do not stop taking your daily Parkinson's medicine.</b> INBRIJA does not replace your regular carbidopa/levodopa medicine</li>
                <li><b>Do not swallow or open INBRIJA capsules.</b> Only use INBRIJA capsules with the INBRIJA inhaler</li>
                <li><b>Do not use the INBRIJA inhaler for any other medicine.</b></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="helpful-hints" ref={helpful} id="helpful">
          <div className="container">
            <h3>Using INBRIJA may take some practice at <br className="br-desktop" /> first. Below are some helpful hints.</h3>
            <div className="helpful-hints-contianer">
              <ul>
                <li>
                  <img
                    onLoad={handleImageLoads}
                    src="/assets/images/list-arrow.webp" height={49} width={49} className="img-fluid" alt="bullet icon" />
                  <div className="content">
                    <b>Stand or sit up straight and hold the inhaler level and away from your mouth.</b> Breathe out completely. Do not breathe into the mouthpiece.
                  </div>
                </li>
                <li>
                  <img
                    onLoad={handleImageLoads}
                    src="/assets/images/list-arrow.webp" className="img-fluid" alt="bullet icon" height={49} width={49} />
                  <div className="content">
                    <b>Close your lips firmly around the mouthpiece. Breathe in slowly and gently, enough to hear or feel the capsule whirl (this means you are getting your medicine).</b>
                  </div>
                </li>
                <li>
                  <img
                    onLoad={handleImageLoads}
                    src="/assets/images/list-arrow.webp" className="img-fluid" alt="bullet icon" height={49} width={49} />
                  <div className="content">
                    <b>You may take more than one breath</b> per capsule if it's easier for you
                  </div>
                </li>
                <li>
                  <img
                    onLoad={handleImageLoads}
                    src="/assets/images/list-arrow.webp" className="img-fluid" alt="bullet icon" height={49} width={49} />
                  <div className="content">
                    <b>It is quite common to cough</b> as you breathe in, but try not to. <b>If you cough out the medicine, it will reduce the amount you receive</b> in your body<span className="show_mobile">.</span>
                    <ul>
                      <li>– Some people have found that sipping liquid before and after breathing in the medicine helps with cough</li>
                      <li>– As you're breathing in, if you feel like you might cough:
                        <ul>
                          <li>Hold your breath for a few seconds</li>
                          <li>Wait until the feeling goes away</li>
                          <li>Take a sip of liquid</li>
                          <li>Breathe in again with the same capsule</li>
                        </ul>
                      </li>
                      <li>– For some people, coughing may feel like the sensation of choking</li>
                      <li>– And <b>don't forget,</b> if you cough, it's expected. Just breathe in again with the same capsule</li>
                    </ul>
                  </div>
                </li>
                <li>
                  <img
                    onLoad={handleImageLoads}
                    src="/assets/images/list-arrow.webp" className="img-fluid" alt="bullet icon" height={49} width={49} />
                  <div className="content">
                    <strong>To clean the inhaler</strong>, use a new, dry cotton swab to wipe the powder off of the holes from both sides of the mouthpiece with a circular motion. (See Step 14 in <a href="/pdfs/inbrija-patient-info-IFU.pdf" className={DisableClick()} target="_blank" id="how_IFU_2">Instructions For Use</a>)<span className="show_mobile">.</span>
                    <ul>
                      <li>– You can also use a dry tissue to wipe the outside of the mouthpiece</li>
                      <li>– <strong>Do not clean any other parts</strong> of the inhaler. <b>Do not rinse the mouthpiece or get the inhaler wet</b></li>
                    </ul>
                  </div>
                </li>
              </ul>
               <a className={`primary-link helpful-hints-button`} href="/pdfs/helpful-hints.pdf" target="_blank" id="how_helpful_hints_download"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M7 10L12 15L17 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 15V3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg> Download these hints for easy access
              </a>
            </div>
          </div>
          <img src="/assets/images/Tennis-Supporting.webp" className="tennis" alt={`A man prepares to serve a tennis ball. Writing on his arm says "I'm hitting back."`} />
        </div>

        <NavigationBar
          leftNavigation="Prepare for Discussions With Your Doctor"
          leftNavigationLink="/about-inbrija#talking-with-doctor"
          leftNavigationid="how_talk_doctor"
          rightNavigation="Learn How to Use INBRIJA"
          rightNavigationLink="/how-to-use-inbrija#learn-how-use-inbrija"
          rightNavigationid="how_learn_how_use"
        />
        <div ref={myRef}>
          <Isi />
        </div>
        {show ? <IsiFrame onClick={executeScroll} /> : ''}
        <Footer partNum="01/25 US-INB-2400111"
          facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2Fhow-to-use&title=Inhaled%20Delivery&description=Watch%20a%20demonstration%20video%20on%20how%20to%20use%20INBRIJA."
          twitterCode="https://twitter.com/intent/tweet?text=Inhaled%20Delivery.%20Watch%20a%20demonstration%20video%20on%20how%20to%20use%20INBRIJA.%20https://www.inbrija.com/how-to-use"
        />
        <Modal show={showJimmy} muted={false} src="/videos/patient-videos-jimmy.mp4" title="Jimmy's Story" handleClose={() => setShowJimmy(false)} videoTrack="videos/patient-videos-jimmy.vtt" />
      </div>
    </MainLayout>
  )
}